import PoliticalDashboardPage from "./pages/politicalParty/PoliticalPages/PoliticalDashboardPage";
import PoliticalDocumentPage from "./pages/politicalParty/PoliticalPages/PoliticalDocumentPage";
import PoliticalExecutiveMembersPage from "./pages/politicalParty/PoliticalPages/PoliticalExecutiveMembersPage";
import PoliticalPartyAgentPage from "./pages/politicalParty/PoliticalPages/PoliticalPartyAgentPage";
import PoliticalRegisteredElectorsPage from "./pages/politicalParty/PoliticalPages/PoliticalRegisteredElectorsPage";
import PoliticalRegistredAndNonRegisteredPage from "./pages/politicalParty/PoliticalPages/PoliticalRegistredAndNonRegisteredPage";
import PoliticalRepresentativesPage from "./pages/politicalParty/PoliticalPages/PoliticalRepresentativesPage";
import { Reports } from "./pages/reports/Reports";
import ResultsManagementPage from "./pages/ResultManagement/ResultsManagementPage";

export const menu = [
    {
        label: "Home",
        items: [
            {
                label: "Dashboard",
                icon: "pi pi-fw pi-home",
                to: "/"
            },
        ]
    }
];

export function ResultManagementGenerateRoutesAndMenu(azureLoginState) {
    var routes = {
        "/": { component: ResultsManagementPage },

    };

    return { menu: menu, routes: routes };
}
